import { render, staticRenderFns } from "./GroupGoods.vue?vue&type=template&id=436a19b2&scoped=true&"
import script from "./GroupGoods.vue?vue&type=script&lang=js&"
export * from "./GroupGoods.vue?vue&type=script&lang=js&"
import style0 from "../../style.css?vue&type=style&index=0&id=436a19b2&prod&scoped=true&lang=css&"
import style1 from "./GroupGoods.vue?vue&type=style&index=1&id=436a19b2&prod&scoped=true&lang=css&"
import style2 from "./GroupGoods.vue?vue&type=style&index=2&id=436a19b2&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436a19b2",
  null
  
)

export default component.exports